import { Shield, ShieldCheck, Star, Crown } from "lucide-react";
import { cn } from "@/lib/utils";

export type Tier = "basic" | "verified" | "pro" | "elite";

const META: Record<Tier, { label: string; cls: string; Icon: React.ComponentType<{ className?: string }> }> = {
  basic:    { label: "Basic Hustler",    cls: "bg-muted text-muted-foreground border-border", Icon: Shield },
  verified: { label: "Verified",         cls: "bg-primary/15 text-primary border-primary/30", Icon: ShieldCheck },
  pro:      { label: "Pro Hustler",      cls: "bg-accent/20 text-accent-foreground border-accent/40", Icon: Star },
  elite:    { label: "Elite Isle",       cls: "bg-gradient-to-r from-accent/30 to-primary/30 text-foreground border-accent/50", Icon: Crown },
};

export const TierBadge = ({ tier, className, compact }: { tier: Tier; className?: string; compact?: boolean }) => {
  const m = META[tier] ?? META.basic;
  const Icon = m.Icon;
  return (
    <span className={cn("inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider", m.cls, className)}>
      <Icon className="h-3 w-3" />
      {compact ? tier : m.label}
    </span>
  );
};
